// src/components/Carousel/useCarousel.js

import { useCallback, useEffect } from 'react'

const useCarousel = (carrosselRef) => {
  const centralizeItem = useCallback(
    (item) => {
      if (!carrosselRef.current) return

      const carrossel = carrosselRef.current
      const itemCenterPosition = item.offsetLeft + item.offsetWidth / 2
      const carrosselCenterPosition = carrossel.offsetWidth / 2
      const scrollTo = itemCenterPosition - carrosselCenterPosition

      carrossel.scroll({
        left: scrollTo,
        behavior: 'smooth'
      })
    },
    [carrosselRef]
  )

  const handleScroll = () => {
    if (!carrosselRef.current) return

    const carrossel = carrosselRef.current
    const centerPosition = carrossel.scrollLeft + carrossel.offsetWidth / 2
    let closestItem = carrossel.children[0]
    let minDistance = Math.abs(
      centerPosition - (closestItem.offsetLeft + closestItem.offsetWidth / 2)
    )

    Array.from(carrossel.children).forEach((item) => {
      const itemCenterPosition = item.offsetLeft + item.offsetWidth / 2
      const distance = Math.abs(centerPosition - itemCenterPosition)
      if (distance < minDistance) {
        closestItem = item
        minDistance = distance
      }
    })

    centralizeItem(closestItem)
  }

  useEffect(() => {
    const carrossel = carrosselRef.current
    if (!carrossel) return

    carrossel.addEventListener('scroll', handleScroll)

    return () => {
      carrossel.removeEventListener('scroll', handleScroll)
    }
  }, [carrosselRef, handleScroll])

  return { centralizeItem }
}

export default useCarousel
